import React from 'react';
import { useRouter, withRouter } from 'next/router';
import { getRoutePath } from '@routes/routes.util';

const withNav = (WrappedComponent) => {
  function WithNav(props) {
    const router = useRouter();
    const locale = router.asPath.split('/')[1];
    /**
     * @canBeRemovedLater
     * If this isn't necessary, we can remove this function and use the navigate function instead.
     */
    const redirect = (routeName, params = {}) => {
      let routePath = getRoutePath({ routeName, locale, params });

      const hasPathPlaceholder = (str) => /:/.test(str);

      if (hasPathPlaceholder(routePath)) {
        const afterColonMatcher = /:(.*)$/;
        const colonMatcher = /.:/;
        routePath = routePath.replace(afterColonMatcher, ':').replace(colonMatcher, '');
      }
      return router.push(routePath);
    };

    /**
     * Navigates to a specific route.
     *
     * @param {string} routeName - The name of the route to navigate to.
     * @param {Object} [params={}] - Optional parameters for the route.
     * You can pass params such as {propertyId: 1, supplierId: 1}
     * @returns {void}
     */
    const navigate = (routeName, params = {}, query = {}) => {
      const routePath = getRoutePath({ routeName, locale, params });
      return router.push({
        pathname: routePath,
        query
      });
    };
    return <WrappedComponent {...props} redirect={redirect} navigate={navigate} />;
  }
  return withRouter(WithNav);
};

export default withNav;
